import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  MfinExciseLicenceRequestListPayload,
  MfinExciseStampRequestListPayload,
  MfinExciseWarehouseListPayload,
  MfinListaEvidentiranihAkciznihMarkicaPayload,
} from "./ministry.types";

/**
 * Keys used to invalidate stored cached data regarding mfin excise stamp module
 */
export const mfinKeys = createQueryKeys("mfin", {
  exciseStampRequestList: ({
    filters,
  }: {
    filters: Partial<MfinExciseStampRequestListPayload>;
  }) => ({
    queryKey: ["excise_stamp_request_list", filters],
  }),
  exciseLicenceRequestList: ({
    filters,
  }: {
    filters: Partial<MfinExciseLicenceRequestListPayload>;
  }) => ({
    queryKey: ["excise_licence_request_list", filters],
  }),
  exciseWarehouseList: ({
    filters,
  }: {
    filters: Partial<MfinExciseWarehouseListPayload>;
  }) => ({
    queryKey: ["exicse_warehouse_list", filters],
  }),
  evidentiraneMarkiceList: ({
    filters,
  }: {
    filters: Partial<MfinListaEvidentiranihAkciznihMarkicaPayload>;
  }) => ({
    queryKey: ["evidentirane_markice_list", filters],
  }),
});
